import Script from 'next/script';
import { type FC } from 'react';

const Usetiful: FC = () => (
  <Script
    src="https://www.usetiful.com/dist/usetiful.js"
    id="usetifulScript"
    async
    data-token="e2e821a3b2e5c078a24ea2ff20323bb1"
  />
);

export default Usetiful;
